import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { CoreService } from '../modules/core/services/core.service';
import * as AppStoreActions from '../store/app-store.actions';

const LocalStorageItemName = 'simxAdminPortal';

@Injectable()
export class AppStoreEffects implements OnInitEffects {
  private _actions$ = inject(Actions);
  private _coreService = inject(CoreService);
  private _store = inject(Store);

  ngrxOnInitEffects(): Action {
    return AppStoreActions.hydrateAppState();
  }

  hydrateAppState$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AppStoreActions.ActionTypes.HydrateAppState),
      map(() => {
        const localStorageItem = localStorage.getItem(LocalStorageItemName);
        if (!localStorageItem) return AppStoreActions.hydrateAppStateFailed();

        let parsedLocalStorageItem;
        try {
          parsedLocalStorageItem = JSON.parse(localStorageItem);
        } catch {
          localStorage.removeItem(LocalStorageItemName);
        }

        const appReleaseVersion = this._coreService.getAppReleaseVersion();
        if (
          parsedLocalStorageItem &&
          parsedLocalStorageItem.app?.appReleaseVersion === appReleaseVersion
        ) {
          return AppStoreActions.hydrateAppStateSucceeded({
            state: parsedLocalStorageItem,
          });
        } else {
          return AppStoreActions.hydrateAppStateFailed();
        }
      }),
    ),
  );

  storeAppState$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(
          AppStoreActions.ActionTypes.HydrateAppStateSucceeded,
          AppStoreActions.ActionTypes.HydrateAppStateFailed,
        ),
        switchMap(() => this._store),
        distinctUntilChanged(),
        tap(state => {
          localStorage.setItem(LocalStorageItemName, JSON.stringify(state));
        }),
      ),
    {
      dispatch: false,
    },
  );
}
